import { render, staticRenderFns } from "./lclRealList.vue?vue&type=template&id=1aa43d36&scoped=true&"
import script from "./lclRealList.vue?vue&type=script&lang=js&"
export * from "./lclRealList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa43d36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aa43d36')) {
      api.createRecord('1aa43d36', component.options)
    } else {
      api.reload('1aa43d36', component.options)
    }
    module.hot.accept("./lclRealList.vue?vue&type=template&id=1aa43d36&scoped=true&", function () {
      api.rerender('1aa43d36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/PriceReal/components/PriceReal/lclRealList.vue"
export default component.exports